import { Controller } from "@hotwired/stimulus"
import throttle from "lodash-es/throttle"
import qs from "qs"

export default class extends Controller {
  static values = {
    configurationId: { type: String, default: null },
    participantId: { type: String, default: null },
    sampleTextId: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    interval: { type: Number, default: 100 },
    flush: { type: Number, default: 1000 }
  }

  connect() {
    this.eventQueue = [];
    if (this.disabledValue) return

    this.trackEventsUrl = `/track_events?configuration_id=${this.configurationIdValue}&participant_id=${this.participantIdValue}&sample_text_id=${this.sampleTextIdValue}`

    this._mouseOverHandler = throttle((e) => this.recordEvent(e), this.intervalValue)
    this.element.addEventListener("mouseover", this._mouseOverHandler)

    this._clickHandler = (e) => this.recordEvent(e)
    this.element.addEventListener("click", this._clickHandler)

    this._visibilityHandler = () => this.flushEvents()
    document.addEventListener("visibilitychange", this._visibilityHandler)

    this.flushInterval = setInterval(() => this.flushEvents(), this.flushValue);
  }

  disconnect() {
    if (this.disabledValue) return

    // this.element.removeEventListener("mouseover", this._mouseOverHandler)
    this.element.removeEventListener("click", this._clickHandler)
    document.removeEventListener("visibilitychange", this._visibilityHandler)

    clearInterval(this.flushInterval);

    this.flushEvents();
  }

  recordEvent(event) {
    if (this.disabledValue) return

    const el = event.target.closest("[data-track-id]")
    if (!el) return

    const text_content = el.tagName === "SELECT" ?
      el.options[el.selectedIndex]?.textContent?.trim()
      : el.dataset.trackTextContent || el.textContent.trim()

    const timestamp = (new Date()).toISOString()
    this.eventQueue.push({ event_type: event.type, track_id: el.dataset.trackId, text_content, timestamp })
  }

  flushEvents() {
    if (this.disabledValue) return
    if (!this.eventQueue.length) return;

    const authenticity_token = document.querySelector("meta[name='csrf-token']").getAttribute("content")
    const payload = qs.stringify({ track_events: this.eventQueue, authenticity_token })
    // Use Blob with this encoding to allow rails to validate authenticity token (does not work with JSON)
    const blob = new Blob([payload], { type: 'application/x-www-form-urlencoded' })
    const enqueued = navigator.sendBeacon(this.trackEventsUrl, blob)

    if (enqueued) {
      this.eventQueue = [];
    }
  }
}
